import { render, staticRenderFns } from "./ScreenLock.vue?vue&type=template&id=5d953ffc&"
import script from "./ScreenLock.vue?vue&type=script&lang=js&"
export * from "./ScreenLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports